import { createFileRoute, Link } from '@tanstack/react-router';

function FilesPage() {
  const params = Route.useParams();
  const splatPath = params['*'] || '';
  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1 style={{ marginBottom: '10px', color: '#333' }}>Splat / Catch-All Route</h1>
      <p style={{ marginBottom: '20px', color: '#666', fontSize: '14px' }}>
        $ 세그먼트를 사용해 나머지 모든 경로를 캡처합니다. 파일 경로, 깊은 중첩 구조 등에 유용합니다.
      </p>
      <p style={{ padding: '10px', background: '#f0f0f0', borderRadius: '4px', marginBottom: '20px' }}>
        Captured path: <strong>{splatPath || '(없음)'}</strong>
      </p>
      <Link to="/" style={{ color: '#0066cc' }}>← 홈으로</Link>
    </div>
  );
}

export const Route = createFileRoute('/sample/files/$')({
  component: FilesPage,
});

